import { EpisodeContent, MovieContent, SeasonContent, SeriesContent } from '../../../domain';

export enum ContentViewModelCarouselType {
  Basic = 'Basic',
  ContinueWatching = 'ContinueWatching',
  MyList = 'MyList',
  Reccommendation = 'Reccommendation',
  Season = 'Season',
  Hero = 'Hero',
}

export interface MovieContentViewModel extends MovieContent {
  type: 'movie';
}

export interface SeriesContentViewModel extends SeriesContent {
  type: 'series';
}

export interface SeasonContentViewModel extends SeasonContent {
  type: 'season';
}

export interface EpisodeContentViewModel extends EpisodeContent {
  type: 'episode';
}

export type ContentViewModel = MovieContentViewModel | SeriesContentViewModel | SeasonContentViewModel | EpisodeContentViewModel;
